import React from 'react';

import { defineMessages, useIntl } from 'react-intl';

import ClockIcon from '@atlaskit/icon/core/clock';
import { token } from '@atlaskit/tokens';

const messages = defineMessages({
	iconLabel: {
		id: 'update-work-item-fields-action-renderer.ui.action-card.time-tracking-field.icon-label',
		defaultMessage: 'Time tracking field',
		description:
			'Accessible label for the icon representing the time tracking field in a Jira work item action card.',
	},
});

export const TimeTrackingFieldIcon = (): React.JSX.Element => {
	const { formatMessage } = useIntl();
	return (
		<ClockIcon
			label={formatMessage(messages.iconLabel)}
			size="small"
			color={token('color.icon.subtle')}
		/>
	);
};
